/**
 * paymentNotes.ts — the INTERIM payment-note marker (UX Wave 6 §3).
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: UX Wave 6 (payments correctness).
 *
 * WHY: the admin Payments drawer needs a PAYMENT notes thread, but the
 * orders-service case-notes store has no scope/kind field yet ([BACKEND
 * FOLLOW-UP] — Wave-6 §3 wants kind='payment' server-side). Until that lands,
 * payment notes ride the SAME per-case notes API with a leading plain-text
 * `[payment]` marker — plain text survives the server's tag-allowlist
 * sanitiser, so the marker round-trips — and BOTH surfaces filter
 * client-side: the payments drawer (admin/PaymentNotes.tsx) renders ONLY
 * marked notes, and the clinical thread (clinicians/CaseNotes.tsx) renders
 * only unmarked ones, so payment chatter never lands on a clinical surface
 * and clinical notes never render in a payments context. Swap these helpers
 * for the true kind='payment' field (and delete this module) once the
 * backend follow-up ships.
 */

/** The leading plain-text token that tags a case note as a PAYMENT note. */
export const PAYMENT_NOTE_MARKER = '[payment]';

/** Tag an outgoing note body as a payment note (compose/edit writes). */
export function withPaymentMarker(html: string): string {
  return `${PAYMENT_NOTE_MARKER} ${html}`;
}

/**
 * Does this stored body carry the payment marker? Tag-strip then look at the
 * LEADING plain text — tolerant of the server sanitiser re-wrapping the body
 * (the marker only has to lead the text content, not the raw string).
 */
export function isPaymentNote(body: string): boolean {
  return body.replace(/<[^>]*>/g, '').trimStart().startsWith(PAYMENT_NOTE_MARKER);
}

/** Remove the (first) marker for display/edit — the reader never sees the token. */
export function stripPaymentMarker(body: string): string {
  return body.replace(/\[payment\]\s*/, '');
}
